import CityPageTemplate from "../city-template/CityPageTemplate";
import { jamestownNDConfig } from "./data";

export default function JamestownNDPage() {
  return <CityPageTemplate config={jamestownNDConfig} />;
}